export const getBrandCodeForDb = (code: string) => {
  switch (code) {
    case 'dh_wb':
      return 'dh'
    case 'bibibop':
      return 'bbb'
    case 'sullivans':
    case 'sullivans_nso':
    case 'eddiemerlots':
    case 'eddiemerlots_nso':
      return 'drg'

    default:
      return code
  }
}
